module.exports = __webpack_public_path__ + "static/Stuart-Convenience-Store-1005-W-Stuart-St-Fort-Collins-CO-80526-2e25bac6aca072dcdf4a04f44bb0d0ab.jpg";